
const user = {
    state: {
        token: localStorage.getItem('token'),
        userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
        whetherShare: localStorage.getItem('whetherShare'),
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERNAME: (state, data) => {
            state.userName = data
        },
        SET_WHETHERSHARE: (state, data) => {
            state.whetherShare = data
        },
    },

    actions: {
        // 保存token
        setToken({ commit }, data) {
            commit('SET_TOKEN', data)
        },
        // 保存用户名
        setUserName({ commit }, data) {
            commit('SET_USERNAME', data)
        },
        // 报告分享状态
        setWhetherShare({ commit }, data) {
            commit('SET_WHETHERSHARE', data)
        },
    }
}

export default user
